/**
 * Constants for Analytics component
 */

export const ANALYTICS_COLORS = {
  PRIMARY: '#5E65D1',
  AVERAGE: '#a7c957',
  PREVIOUS: '#73BFB8',
  PRODUCT: [
    '#3b82f6',
    '#ef4444',
    '#10b981',
    '#f97316',
    '#8b5cf6',
    '#64748b',
    '#d946ef'
  ]
} as const;

export const DEFAULT_ALL_DRINKS = [
  'French Vanilla',
  'Latte',
  'Cappuccino',
  'Americano',
  'Mocha',
  'Espresso',
  'Hot Chocolate',
  'Cortado',
  'Chai Latte'
] as const;

export const CHART_CORNER_RADIUS = 4;
export const CHART_UPDATE_DELAY = 200;
export const CHART_UPDATE_RETRY_DELAY = 300;
export const DEFAULT_CHART_ITEM_LIMIT = 10;

